<template>
    <div class="container">
        <div class="row">
            <div class="col-lg-4">
                <h2 class="h h--2 h--dark">Historia punktów</h2>
                <p class="paragraph">Sprawdź skąd wzięła się sumaryczna pula Twoich punktów, analizując wyniki przedstawione w tabeli.</p>

                <user-points-info-widget/>
                

            </div>
            <div class="col-lg-8" v-bind:class="{'pending': pagination.pending}">
                <div v-if="points.length > 0">
                  <table class="invoices__table">
                      <tr>
                          <th>Rodzaj operacji</th>
                          <th>liczba punktów wykorzystana/zgromadzona</th>
                          <th>Opis</th>
                          <th>Data dodania</th>
                          <th>Data ważności</th>
                      </tr>
                      <tr v-for="item in points" :key="item.id" :style="[item.is_income && item.is_expired ? { 'opacity': 0.5} : {} ]">
                          <td>{{ item.is_income ? "Uznanie" : "Obciążenie" }}</td>

                          <td style="white-space: nowrap; ">
                            <span v-if="!item.is_income" style="color: #ff3b00">
                            {{ item.difference | pointDecimal }}
                            </span>
                            <span v-else-if="item.is_expired" style="text-decoration: line-through;">
                                <small>{{ item.spent | pointDecimal }} / </small> {{ item.difference | pointDecimal }}
                            </span>
                            <span v-else style="white-space: nowrap; color: #00A8A1">
                              <span v-if="item.is_premium" title="Punkty tylko dla Certyfikowanych użytkowników">
                                  <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-unlock-fill" viewBox="0 0 16 16">
                                    <path v-if="user.is_certyficated" d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2z"/>
                                    <path v-else d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                                  </svg>
                              </span>
                              <small>{{ item.spent | pointDecimal }} / </small> {{ item.difference | pointDecimal }}
                            </span>
                          </td>

                          <td>{{ item.description }}</td>
                          <td class="invoices__column-date">{{ moment(item.created_at).format('DD.MM.YYYY HH:MM') }}</td>
                          <td v-if="item.is_income" class="invoices__column-date">
                            <span v-if="item.is_expired">{{ (item.expire_at == null)?'':item.expire_at.replace('00:00:00','') }}</span>
                            <span v-else-if="item.is_expire_near" style="color:#ffa500">{{ (item.expire_at == null)?'':item.expire_at.replace('00:00:00','') }}</span>
                            <span v-else style="color:#00a8a1">{{ (item.expire_at == null)?'':item.expire_at.replace('00:00:00','') }}</span>
                          </td>
                          <td v-else>-</td>
                      </tr>
                  </table>
                  <pagination v-model="pagination.current_page" :page="pagination.current_page" :per-page="parseInt(pagination.per_page)" :records="pagination.total" @paginate="onChangePaginate" v-if="pagination && pagination.last_page > 1"></pagination>
                </div>
                <div class="row profile" v-if="points.length == 0">
                    <div class="col col-12">
                        <p>brak wpisów w historii</p>
                    </div>
                </div>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

export default {
  name: 'PointsComponent',
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  data () {
    return {
      points: [],
      pagination: {},
    }
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
      method: 'get',
      url: '/users/current/pointsHistory'
    })
    .then(response => {
        next(vm => {
          vm.points = response.data.data.points
          vm.pagination = response.data.pagination
        })
    })
    .catch(error => next(false))
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  mounted: function() {
    if( !this.user || this.user.id != 1 ) {
        this.$gtag.pageview({
            page_path: '/punkty',
        })
    }
    
  },
  methods: {
    /**
     * On change paginate event.
     *
     * @param  {int} page
     * @return void
     */
    onChangePaginate(page) {
      let vm = this

      vm.pagination.pending = true

      Vue.axios({
        method: 'get',
        url: '/users/current/pointsHistory',
        params: {
          page: page
        }
      })
      .then(response => {
        vm.points = response.data.data.points
        vm.pagination = response.data.pagination
      })
      .catch(error => vm.pagination.pending = false)
    },

  }

}
</script>



// WEBPACK FOOTER //
// src/app/home/points/PointsComponent.vue